export const initBlockData = {
  title: "Subscribe to our newsletter",
  description:
    "We will send you only valid information regarding discounts and special offers.",
};

export const initEmptyBlockData = {
  title: "",
  description: "",
};
